import { Box, Stack } from '@mui/material';

import ChartWaypoint from './ChartWaypoint';
import type { ChartWaypoint as ChartWaypointType, EntityId } from '@/types';

interface ChartWaypointListProps {
  chartId: EntityId;
  waypoints: ChartWaypointType[];
  onEdit?: (waypoint: ChartWaypointType) => void;
  onDelete?: () => void;
  isEditable?: boolean;
}

function ChartWaypointList({
  chartId,
  waypoints,
  onEdit,
  onDelete,
  isEditable = true,
}: ChartWaypointListProps): React.JSX.Element {
  return (
    <Box>
      {waypoints.length > 0 && (
        <Stack spacing={0.5}>
          {waypoints.map((waypoint) => (
            <ChartWaypoint
              key={waypoint.entity_id}
              waypoint={waypoint}
              chartId={chartId}
              onEdit={onEdit}
              onDelete={onDelete}
              isEditable={isEditable}
            />
          ))}
        </Stack>
      )}
      {waypoints.length === 0 && (
        <Box sx={{ py: 2 }}>
          {/* Empty state - Add button is in the accordion header */}
        </Box>
      )}
    </Box>
  );
}

export default ChartWaypointList;

